import { CompanyPromotionDateOperator } from "@/generated/company-search";

/**
 * SuperKudu-only Company Promotion Date filter: compares the company's first
 * data-tier promotion date (company_locations) with `date` (YYYY-MM-DD).
 */
export type PromotionDateSlice = {
  operator: CompanyPromotionDateOperator;
  date: string | null;
};

export const defaultPromotionDateSlice: PromotionDateSlice = {
  operator: CompanyPromotionDateOperator.GREATER_THAN,
  date: null,
};
